

//匹配文件类型，用来显示对应的图标
export function testFile(name, typeList) {
    let fileType = false
    for (let i of typeList) {
        fileType = name.toLowerCase().includes(i)
        //如果匹配到，停止循环
        if (fileType) {
            break
        }
    }
    return fileType
}


/**
 * 格式化时间
 * @param date Date 时间
 * @param format 格式化 "yyyy-MM-dd hh:mm:ss www"=format
 * @returns {string} 格式化后字符串
 */

export function format(date, format) {
    if (typeof date == 'string') {
        if (date.indexOf('T') >= 0) {
            date = date.replace('T', ' ')
        }
        date = new Date(Date.parse(date.replace(/-/g, "/")))
    }
    date = new Date(date)
    var o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3),
        "S": date.getMilliseconds()
    };
    var w = [
        ['日', '一', '二', '三', '四', '五', '六'],
        ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
        ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
    ];
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    if (/(w+)/.test(format)) {
        format = format.replace(RegExp.$1, w[RegExp.$1.length - 1][date.getDay()]);
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return format;
}

/* 处理服务对象 */
export function targetsFn (strArr) {
     // [0]全部,[1]学生,[2]教师,[3]游客,[4]上级部门,[5]同级部门,[6]部门内部,[7]其他
    let arr = []
    if(strArr.length > 0){
        if(strArr.indexOf('[0]') != -1){
          arr.push('全部')
        }
        if(strArr.indexOf('[1]') != -1){
          arr.push('学生')
        }
        if(strArr.indexOf('[2]') != -1){
          arr.push('教师')
        }
        if(strArr.indexOf('[3]') != -1){
          arr.push('访客')
        }
        if(strArr.indexOf('[4]') != -1){
          arr.push('上级部门')
        }
        if(strArr.indexOf('[5]') != -1){
          arr.push('同级部门')
        }
        if(strArr.indexOf('[6]') != -1){
          arr.push('部门内部')
        }
        if(strArr.indexOf('[7]') != -1){
          arr.push('其他')
        }
    }
    return arr
}